export { default } from './ClosingInformationSection';
